import { Pipe, Inject, LOCALE_ID } from '@angular/core';
import { ConfigService } from '../../providers/config/config.service';
import { AbstractConfigurableDatePipe } from './AbstractConfigurableDatePipe';

@Pipe({name: 'configurableDatetime'})
export class ConfigurableDatetimePipe extends AbstractConfigurableDatePipe {

    private format: string;

    constructor(@Inject(LOCALE_ID) locale: string,
        private configService: ConfigService) {
        super(locale);
        if (configService) {
            this.format = configService.getDisplayDateFormat() + " " + configService.getDisplayTimeFormat();
        }
    }

    protected getFormat(): string {
        return this.format;
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/ConfigurableDatetimePipe.ts